/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface ExternalLinkIconProps {
  width?: number
  height?: number
  fill?: string
}

/**
 * ExternalLinkIcon component displays an external link icon
 */
const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = ({
  width = 12,
  height = 12,
  fill = colors.PRIMARY,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
    >
      <path
        d='M1.33333 12C0.966667 12 0.652667 11.8696 0.391333 11.6087C0.130444 11.3473 0 11.0333 0 10.6667V1.33333C0 0.966667 0.130444 0.652667 0.391333 0.391333C0.652667 0.130444 0.966667 0 1.33333 0H5.33333C5.52222 0 5.68067 0.0637777 5.80867 0.191333C5.93622 0.319333 6 0.477778 6 0.666667C6 0.855556 5.93622 1.01378 5.80867 1.14133C5.68067 1.26933 5.52222 1.33333 5.33333 1.33333H1.33333V10.6667H10.6667V6.66667C10.6667 6.47778 10.7307 6.31933 10.8587 6.19133C10.9862 6.06378 11.1444 6 11.3333 6C11.5222 6 11.6804 6.06378 11.808 6.19133C11.936 6.31933 12 6.47778 12 6.66667V10.6667C12 11.0333 11.8696 11.3473 11.6087 11.6087C11.3473 11.8696 11.0333 12 10.6667 12H1.33333ZM4 8C3.87778 7.87778 3.81667 7.72222 3.81667 7.53333C3.81667 7.34444 3.87778 7.18889 4 7.06667L9.73333 1.33333H8C7.81111 1.33333 7.65289 1.26933 7.52533 1.14133C7.39733 1.01378 7.33333 0.855556 7.33333 0.666667C7.33333 0.477778 7.39733 0.319333 7.52533 0.191333C7.65289 0.0637777 7.81111 0 8 0H11.3333C11.5222 0 11.6804 0.0637777 11.808 0.191333C11.936 0.319333 12 0.477778 12 0.666667V4C12 4.18889 11.936 4.34711 11.808 4.47467C11.6804 4.60267 11.5222 4.66667 11.3333 4.66667C11.1444 4.66667 10.9862 4.60267 10.8587 4.47467C10.7307 4.34711 10.6667 4.18889 10.6667 4V2.26667L4.91667 8.01667C4.79444 8.13889 4.64444 8.2 4.46667 8.2C4.28889 8.2 4.13333 8.13333 4 8Z'
        fill={fill}
      />
    </svg>
  )
}

export default ExternalLinkIcon
